export const PaulaEvents = {};

PaulaEvents.hasActiveEvent = () => {
}

PaulaEvents.displayHint = () => {
}
 
/*
- ...
 */
PaulaEvents.genericTalk_1 = () => {
  return !PaulaEvents.hasActiveEvent();
}

PaulaEvents.isFirstEvent = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  return !EventStateService.paulaFirstEvent;
}
